import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class RegisterDeviceUseCase extends BaseUseCase {
    constructor(registerdDeviceRep) {
        super();
        this.registerdDeviceRep = registerdDeviceRep;
    }
    async fetchResult(req) {
        return await this.registerdDeviceRep.registerDeviceDetailsData(req);
    }
}
export default RegisterDeviceUseCase;
